export default "__VITE_ASSET__837fce81__"